import { Form } from "sharedTypes"

const formIdsOfType = (forms: Pick<Form, "externalId" | "type">[], type: string) => (
  forms.filter((form) => form.type === type).map(({ externalId }) => externalId)
)

export default formIdsOfType
